import { Component, ViewChild } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as _ from 'lodash';

@Component({
  templateUrl: './demographics.component.html'
})
export class DemographicsComponent {
  @ViewChild('demographicsForm') form;

  isSubmitting: boolean;
  attendee: any;
  ageRange;
  ages = [
    { display: '18-24 years of age', value: '18-24' },
    { display: '25-34 years of age', value: '25-34' },
    { display: '35-44 years of age', value: '35-44' },
    { display: '45-54 years of age', value: '45-54' },
    { display: '55-64 years of age', value: '55-64' },
    { display: '65 or older', value: '65 or older' },
    { display: 'Prefer not to answer', value: 'Prefer not to answer' },
  ];
  gender;
  genders = [
    { display: 'Male', value: 'Male' },
    { display: 'Female', value: 'Female' },
    { display: 'Other', value: 'Other' },
    { display: 'Prefer not to answer', value: 'Prefer not to answer' },
  ];
  otherGender;
  ethnicity;
  ethnicities = [
    { display: 'White', value: 'White' },
    { display: 'Black or African American', value: 'Black or African American' },
    { display: 'American Indian or Alaskan Native', value: 'American Indian or Alaskan Native' },
    { display: 'Asian', value: 'Asian' },
    { display: 'Native Hawaiian or other Pacific Islander', value: 'Native Hawaiian or other Pacific Islander' },
    { display: 'From multiple races', value: 'From multiple races' },
    { display: 'Other', value: 'Other' },
    { display: 'Prefer not to answer', value: 'Prefer not to answer' },
  ];
  ethnicityOther;
  firstTime;
  firstTimeValue;
  jobRole;
  jobRoles = [
    { display: 'Producing Advisor - Solo Practice', value: 'Producing Advisor - Solo Practice' },
    { display: 'Producing Advisor - Ensemble Team', value: 'Producing Advisor - Ensemble Team' },
    { display: 'OSJ/Enterprise Leader', value: 'OSJ/Enterprise Leader' },
    { display: 'Program Manager', value: 'Program Manager' },
    { display: 'Paraplanner', value: 'Paraplanner' },
    { display: 'Operations/Service Lead', value: 'Operations/Service Lead' },
  ]
  numEmployees;
  numbers = [
    { display: '1-10 employees at my business', value: '1-10 employees at my business' },
    { display: '11-50 employees at my business', value: '11-50 employees at my business' },
    { display: '51-100 employees at my business', value: '51-100 employees at my business' },
    { display: '101-500 employees at my business', value: '101-500 employees at my business' },
    { display: '501 or more employees at my business', value: '501 or more employees at my business' },
  ];
  financialExperience;
  experiences = [
    { display: 'Less than 1 year of financial experience', value: 'Less than 1 year of financial experience'},
    { display: '1-5 years of financial experience', value: '1-5 years of financial experience'},
    { display: '6-10 years of financial experience', value: '6-10 years of financial experience'},
    { display: '11-15 years of financial experience', value: '11-15 years of financial experience'},
    { display: 'More than 15 years of financial experience', value: 'More than 15 years of financial experience'},
  ]
  averageAum;
  aums = [
    { display: '$0-9M average AUM', value: '$0-9M average AUM' },
    { display: '$10-24M average AUM', value: '$10-24M average AUM' },
    { display: '$25-49M average AUM', value: '$25-49M average AUM' },
    { display: '$50-99M average AUM', value: '$50-99M average AUM' },
    { display: '$100+M average AUM', value: '$100+M average AUM' },
  ];
  businessAffiliation;
  affiliations = [
    { display: 'Independent', value: 'Independent' },
    { display: 'Institution (Bank or Credit Union)', value: 'Institution (Bank or Credit Union)' },
    { display: 'RIA', value: 'RIA' },
    { display: 'Hybrid (Independent & Institution)', value: 'Hybrid (Independent & Institution)' }
  ];
  investmentStrategy;
  investmentStrategies = [
    { name: 'Alternative Investments', code: 'Alternative Investments'},
    { name: 'Buffered Products', code: 'Buffered Products'},
    { name: 'Employer Retirement Plans', code: 'Employer Retirement Plans'},
    { name: 'ETFs', code: 'ETFs'},
    { name: 'High Net Worth', code: 'High Net Worth'},
    { name: 'Models', code: 'Models'},
    { name: 'SMAs', code: 'SMAs'},
  ];
  altInvestments;
  bufferedProd;
  employerRetirement;
  etfs;
  highWorth;
  models;
  smas;
  aiVehicles;
  smaStrat;
  receiveDigital;
  digitalCredit;
  contactMethod;
  braindate;
  contactMethods = [
    { name: 'Email', code: 'Email'},
    { name: 'Phone Call', code: 'Phone Call'},
    { name: 'In-Person Meeting', code: 'In-Person Meeting'}
  ];

  emailFormArray: Array<any> = [];
  otherChecked: boolean;

  isFormCompleted = false;




  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService
  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.attendee.$mtcChosenStrategies = [];
    this.firstTime = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FIRST_TIME.ID,
      {}
    );
    this.ageRange = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AGE_RANGE.ID,
      {}
    );
    this.gender = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.GENDER.ID,
      {}
    );
    this.ethnicity = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.ETHNICITY.ID,
      {}
    );
    this.jobRole = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BUSINESS_JOB_ROLL.ID,
      {}
    );
    this.numEmployees = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.NUMBER_OF_EMPLOYEES.ID,
      {}
    );
    this.financialExperience = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.FINANCIAL_EXPERIENCE.ID,
      {}
    );
    this.averageAum = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AVERAGE_AUM.ID,
      {}
    );
    this.businessAffiliation = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BUSINESS_AFFILIATION.ID,
      {}
    );
    this.altInvestments = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_ALTERNATIVE_INVESTMENTS.ID,
      {}
    );
    this.bufferedProd = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_BUFFERED_PRODUCTS.ID,
      {}
    );
    this.employerRetirement = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_EMPLOYER_RETIREMENT_PLANS.ID,
      {}
    );
    this.etfs = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_ETFS.ID,
      {}
    );
    this.highWorth = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_HIGH_NET_WORTH.ID,
      {}
    );
    this.models = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_MODELS.ID,
      {}
    );
    this.smas = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.IS_SMAS.ID,
      {}
    );
    this.aiVehicles = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.AI_VEHICLES.ID,
      {}
    );
    this.smaStrat = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.SMA_STRATEGIES.ID,
      {}
    );
    this.receiveDigital = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DC_BREAKOUT_SESSIONS.ID,
      {}
    );
    this.digitalCredit = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.DC_CE_CREDITS.ID,
      {}
    );
    this.contactMethod = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.PREFERRED_CONTACT.ID,
      {}
    );
    this.braindate = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.BRAINDATE_AMBASSADOR.ID,
      {}
    );

    //Set gender when coming back to page
    if ( this.gender.Value ) {
      if ( this.gender.Value.includes('Other:') ) {
        this.otherGender = this.gender.Value.slice(7);
        this.gender.Value = "Other";
        console.log(this.otherGender);
      }
    }

    //Set ethnicity when coming back to the page
    if ( this.ethnicity.Value ) {
      if ( this.ethnicity.Value.includes('Other:') ) {
        this.ethnicityOther = this.ethnicity.Value.slice(7);
        this.ethnicity.Value = "Other";
        console.log(this.ethnicityOther);
      }
    }

    //Reset Chosen Strategies for the checkboxes
    if ( this.altInvestments.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('Alternative Investments');
    }

    if ( this.bufferedProd.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('Buffered Products');
    }

    if ( this.employerRetirement.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('Employer Retirement Plans');
    }

    if ( this.etfs.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('ETFs');
    }

    if ( this.highWorth.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('High Net Worth');
    }

    if ( this.models.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('Models');
    }

    if ( this.smas.Value === true ) {
      this.attendee.$mtcChosenStrategies.push('SMAs');
    }

  }

  /**
   * @function onChangeBestFeature
   * @description On change of best feature selection if it is other shows textarea.
   */
  // onChangeBestFeature() {
  //   this.bestFeatures.Value = this.variablesService.toDelimitedKeysString(this.bestFeaturesSelections);
  //   if(this.bestFeaturesSelections.other){
  //     this.otherChecked = true;
  //   }else{
  //     this.otherChecked = false;
  //   }
  // }

  setStrategy(){
    console.log('setting strategies')
     if(this.attendee.$mtcChosenStrategies.includes('Alternative Investments')){
      this.altInvestments.Value = true;
    } else {
      this.altInvestments.Value = false;
      this.aiVehicles.Value = '';
    }
    if(this.attendee.$mtcChosenStrategies.includes('Buffered Products')){
       this.bufferedProd.Value = true;
     } else {
      this.bufferedProd.Value = false;
     }
     if(this.attendee.$mtcChosenStrategies.includes('Employer Retirement Plans')){
       this.employerRetirement.Value = true;
     } else {
      this.employerRetirement.Value = false; 
     }
     if(this.attendee.$mtcChosenStrategies.includes('ETFs')){
       this.etfs.Value = true;
     } else {
      this.etfs.Value = false;
     }
     if(this.attendee.$mtcChosenStrategies.includes('High Net Worth')){
       this.highWorth.Value = true;
     } else {
      this.highWorth.Value = false;
     }
     if(this.attendee.$mtcChosenStrategies.includes('Models')){
       this.models.Value = true;
     } else {
      this.models.Value = false; 
     }
     if(this.attendee.$mtcChosenStrategies.includes('SMAs')){
       this.smas.Value = true;
     } else {
      this.smas.Value = false;
      this.smaStrat.Value = '';
     }
  }

  includes(arr, val){
    return _.includes(arr, val);
  }

 strategyUpdate(strategy) {
    let justadded = false;
    console.log("strategyUpdate");
    if (!_.includes(this.attendee.$mtcChosenStrategies, strategy.code)) {
      this.attendee.$mtcChosenStrategies.push(strategy.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.$mtcChosenStrategies, strategy.code)) {
      var index = this.attendee.$mtcChosenStrategies.indexOf(strategy.code);
      if (index !== -1) {
        this.attendee.$mtcChosenStrategies.splice(index, 1);
      }
    }
  }


  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted = true;

    if (form.valid) {
      this.setStrategy();
      if (this.gender.Value === 'Other' && this.otherGender) {
        this.gender.Value = 'Other: ' + this.otherGender;
      }
      if (this.ethnicity.Value === 'Other' && this.ethnicityOther) {
        this.ethnicity.Value = 'Other: ' + this.ethnicityOther;
      }
      if(!this.altInvestments.Value) {
        this.aiVehicles.Value = '';
      }
      if (!this.smas.Value) {
        this.smaStrat.Value = '';
      }
      this.isSubmitting = true;
      this.navigationService.forward();
    }
  }
}
